import {defineMessages} from "react-intl";

export const BULK_USER_EXCEL_TRANSLATIONS = defineMessages({
    users: {id: "bulk_user_modification.excel.sheets.users", defaultMessage: "Users"},
    translations: {id: "bulk_user_modification.excel.sheets.translations", defaultMessage: "Translations"},
    locations: {id: "bulk_user_modification.excel.sheets.locations", defaultMessage: "Locations"},
    vendors: {id: "bulk_user_modification.excel.sheets.vendors", defaultMessage: "Vendors"},
    user_packages: {id: "bulk_user_modification.excel.sheets.user_packages", defaultMessage: "User Packages"},
    metadata: {id: "bulk_user_modification.excel.sheets.metadata", defaultMessage: "Metadata"},
});
